import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { orderBy } from "lodash";
import { ButtonComponent } from "~app/common/components/button/button.component";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { DateUtils } from "~app/common/utils/date-utils";
import { IProduktdefinitionHistorik } from "../models/IProduktdefinition";
@Component({
    selector: "rask-produktinstruktioner-historik",
    templateUrl: "./produktinstruktioner-historik.component.html",
    styleUrls: ["./produktinstruktioner-historik.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective,
        RouterLink,
        ButtonComponent
    ]
})
export class ProduktinstruktionerHistorikComponent implements OnInit {
    readonly activeModal = inject(NgbActiveModal);

    data: {
        historik: IProduktdefinitionHistorik[];
        puid: string;
    };

    historik: IProduktdefinitionHistorik[];
    modal = inject(NgbActiveModal);
    ngOnInit(): void {
        this.historik = orderBy(this.data.historik?.map(x => ({
            id: x.id,
            publiceradAv: x.publiceradAv,
            publiceradDatum: DateUtils.formatDateString(x.publiceradDatum, DateUtils.datetimeformat),
            version: x.version
        })), x => x.publiceradDatum, "desc");
    }

    close() {
        this.activeModal.close();
    }

    dateFormat(date: string) {
        return DateUtils.formatDateString(date, DateUtils.datetimeformat);
    }
    dismiss() {
        this.modal.close(ConfirmDialogResponse.cancel);
    }
}
